import React from 'react';
import { Fortellis } from 'fortellis';
import 'fortellis/dist/style.css';
import { useLoggedInUser } from '../../utils/service-utils';

const FortellisBot = ({ auth, entity }) => {
  const loggedInUser = useLoggedInUser(auth, entity);

  if (!auth?.isAuthenticated) return null;

  return (
    <div className="fortellis-bot-container">
      <Fortellis
        user={loggedInUser}
        aivaVoice={true}
        token={auth?.accessToken}
        theme="light"
        isDemo={false}
      />
    </div>
  );
};

export default FortellisBot;
